<template>
    <h2 v-if="!submitted" class="text-2xl font-bold text-center">
      {{
        step === 1
          ? $t("totalForm.heading.step1")
          : step === 2
          ? $t("totalForm.heading.step2")
          : ""
      }}
    </h2>
  </template>
  
  <script lang="ts" setup>
  defineProps<{ step: number; submitted: boolean }>();
  
  </script>
  <script lang="ts">
  export default {};
  </script>
  